import { HttpRequest, HttpResponse } from '@angular/common/http';

export class DocumentRequestBatchMockService {
  /**
   * Mocks the document overview for a specific Document Request Batch.
   *
   * GET /document-request-batches/{batchId}/documents
   */
  public getDocumentOverview(_request: HttpRequest<any>, _batchId: string): HttpResponse<any> {
    return new HttpResponse({
      status: 200,
      body: {
        requested: [
          {
            id: 'doc-2',
            name: 'Tax Residency Certificate',
            description: 'Certificate confirming current tax residency',
            document_type_description: 'Certificate confirming current tax residency',
            year: '2023',
            signature_requirements: 'Written',
            beneficial_owner: 'Pioneers Large Cap Value Fund',
            notes: null,
            rejection_reason: null,
            client_notes_for_portal: null,
            is_queried: true,
            is_expiring: true,
            is_high_value: true,
          },
          {
            id: 'doc-3',
            name: 'Dividend Voucher 2023',
            description: 'Dividend voucher for FY2023',
            document_type_description: 'Dividend voucher for FY2023',
            year: '2023',
            signature_requirements: 'Digital',
            beneficial_owner: null,
            notes: 'Please include all dividend lines',
            rejection_reason: null,
            client_notes_for_portal: null,
            is_queried: false,
            is_expiring: true,
            is_high_value: true,
          },
        ],
        review_required: [
          {
            id: 'doc-1',
            name: 'W-8BEN Form',
            description: 'Certificate of Foreign Status',
            document_type_description: 'Certificate of Foreign Status',
            year: '2022',
            signature_requirements: 'Required',
            beneficial_owner: 'Pioneers Large Cap Value Fund',
            notes: null,
            rejection_reason: 'Signature missing on page 2',
            client_notes_for_portal: 'Please re-upload with all signatures completed in blue ink.',
            is_queried: true,
            is_expiring: false,
            is_high_value: false,
          },
        ],
        awaiting_approval: [
          {
            id: 'doc-6',
            name: 'Power of Attorney',
            description: 'Signed power of attorney',
            document_type_description: 'Signed power of attorney',
            year: '2024',
            signature_requirements: 'Written',
            beneficial_owner: 'Pioneers Large Cap Value Fund',
            notes: null,
            rejection_reason: null,
            client_notes_for_portal: null,
            is_queried: false,
            is_expiring: false,
            is_high_value: false,
          },
        ],
        approved: [
          {
            id: 'doc-4',
            name: 'Proof of Identity',
            description: 'Government-issued photo ID',
            document_type_description: 'Government-issued photo ID',
            year: '2023',
            signature_requirements: 'None',
            beneficial_owner: 'Pioneers Large Cap Value Fund',
            notes: null,
            rejection_reason: null,
            client_notes_for_portal: null,
            is_queried: true,
            is_expiring: false,
            is_high_value: true,
          },
          {
            id: 'doc-5',
            name: 'Bank Statement',
            description: 'Most recent 3-month statement',
            document_type_description: 'Most recent 3-month statement',
            year: null,
            signature_requirements: 'None',
            beneficial_owner: null,
            notes: null,
            rejection_reason: null,
            client_notes_for_portal: null,
            is_queried: false,
            is_expiring: false,
            is_high_value: false,
          },
        ],
      },
    });
  }

  /**
   * Mocks the download of generated files for a specific Document Request Batch.
   * According to the technical design, this endpoint should return a ZIP file URL.
   *
   * POST /document-request-batches/{batchId}/generated-files-archives
   */
  public getGeneratedFilesZip(request: HttpRequest<any>, batchId: string): HttpResponse<any> {
    // Technical Requirement: The frontend MUST issue the request with header Accept: application/zip
    const acceptHeader = request.headers.get('Accept');

    if (acceptHeader !== 'application/zip') {
      return new HttpResponse({
        status: 406,
        statusText: 'Not Acceptable',
        body: { error: 'Accept header must be application/zip' },
      });
    }

    // In a real scenario, this URL would be generated by the wtax-archive-service
    // and returned by Salesforce.
    const mockZipUrl = `https://mock-archive-service.wtax.co/v1/archives/batch-${batchId}-generated-docs.zip`;
    const mockFileName = `batch-${batchId}-docs.zip`;

    return new HttpResponse({
      status: 200,
      body: {
        archive_file_url: mockZipUrl,
        file_name: mockFileName,
      },
    });
  }
}
